module.exports = __webpack_public_path__ + "static/media/menuRestaurant.6ac2b621.png";